import type { Question } from "@pulse/api/surveyApi";
import { createContext } from "react";

export type QuestionContextType = {
    question: Question;
    idx: number;
};

export const QuestionContext = createContext<QuestionContextType | null>(null);
